import React from 'react';
import { DragOverlay } from '@dnd-kit/core';
import { SortableChecklistItem } from './SortableChecklistItem';
import type { ChecklistItem } from '../types';

type ChecklistDragOverlayProps = {
  activeItem: ChecklistItem | null;
};

export const ChecklistDragOverlay: React.FC<ChecklistDragOverlayProps> = ({
  activeItem
}) => {
  return (
    <DragOverlay>
      {activeItem && (
        <SortableChecklistItem
          item={activeItem}
          onEdit={() => {}}
          onDelete={async (_id: string) => {}}
          disabled={true}
          isEditing={false}
        />
      )}
    </DragOverlay>
  );
};
